import { Skeleton } from 'components/Skeleton/Skeleton'

import Styles from './LoadingState.module.scss'

export const LoadingState = () => {
  const titleColumnWidth = ['167px', '188px', '138px', '167px', '188px', '138px']
  const modifiedColumnWidth = ['96px', '88px', '93px', '96px', '88px', '93px']
  const sharedColumnWidth = ['56px', '56px', '56px', '56px', '56px', '56px']
  return (
    <div className={Styles.animatedSkeleton}>
      <span className={Styles.titleColumn}>
        <Skeleton title={false} active={true} paragraph={{ rows: 6, width: titleColumnWidth }} />
      </span>
      <span className={Styles.column}>
        <Skeleton title={false} active={true} paragraph={{ rows: 6, width: modifiedColumnWidth }} />
      </span>
      <span className={Styles.column}>
        <Skeleton title={false} active={true} paragraph={{ rows: 6, width: sharedColumnWidth }} />
      </span>
    </div>
  )
}
